import React, { Component } from 'react'

export class Spinner extends Component {
    render() {
        return (
            <div className={this.props.inline ? "spinner-wrapper-inline" : "spinner-wrapper"}>
                <div className="donut"></div>
            </div>
        )
    }
}

export default Spinner
